export default class MQuoteItem {
    accountCode: string;
    cost: string;
    customerDescription: string;
    decoMargin: string;
    discount: { amount: string, rate: string }
    dropDown: any;
    glAccount: { income: string, expense: string, asset: string }
    hide: string
    id: string
    inhandDate: string
    inhouseId: string
    itemType: string
    kit: { parent: string, child: string, parentRefId: string }
    margin: string
    modifiedPriceBreaks: { locked: boolean, priceBreaks: [] }
    netPrice: string
    poType: string
    price: string
    product: { id: string, code: string, no: string, name: string, sku: string }
    profit: string
    quantity: string
    quoteCustomImage: string[]
    receiving: { complete: string, received: string, customerComplete: string, customerReceived: string }
    rollUp: { deco: string, addon: string, decoAddon: string }
    shipInfo: { date: string, vendor: string, account: string }
    shipTo: { name: string, id: string, alternateId: string, alternateName: string }
    tax: string
    taxable: string
    totalCost: string
    totalPrice: string
    type: string
    uniqueId: string
    vendor: { id: string, name: string, no: string }
    vendorDescription: string
    vouchingStatus: string
    warehouse: string


    constructor(options) {
        this.warehouse = options.warehouse || "";
        this.vouchingStatus = options.vouchingStatus || "";
        this.vendorDescription = options.vendorDescription || "";
        this.uniqueId = options.uniqueId || "";
        this.type = options.type || "";
        this.totalPrice = options.totalPrice || "";
        this.totalCost = options.totalCost || "";
        this.taxable = options.taxable || "";
        this.tax = options.tax || "";
        this.accountCode = options.accountCode || "";
        this.cost = options.cost || "";
        this.customerDescription = options.customerDescription || "";
        this.decoMargin = options.decoMargin || "";
        if (options.discount) {
            this.discount = {
                amount: options.discount.amount || "",
                rate: options.discount.rate || "",
            };
        } else {
            options.contact = {
                rate: "",
                amount: ""
            }
        }
        this.hide = options.hide || "";
        if (options.glAccount) {
            this.glAccount = {
                income: options.glAccount.income,
                expense: options.glAccount.expense,
                asset: options.glAccount.asset
            }
        } else {
            this.glAccount = {
                income: "",
                asset: "",
                expense: ""
            }
        }
        this.id = options.id || "";
        this.inhandDate = options.inhandDate || "";
        this.inhouseId = options.inhouseId || "";
        this.itemType = options.itemType || "";
        if (options.kit) {
            this.kit = {
                parent: options.kit.parent,
                child: options.kit.child,
                parentRefId: options.kit.parentRefId
            }
        } else {
            this.kit = {
                parent: "",
                child: "",
                parentRefId: ""
            }
        }
        if (options.modifiedPriceBreaks) {
            this.modifiedPriceBreaks = {
                locked: options.modifiedPriceBreaks.locked,
                priceBreaks: options.modifiedPriceBreaks.priceBreaks,
            
            }
        } else {
            this.modifiedPriceBreaks = {
                locked: false,               
                priceBreaks: []
            }
        }
        this.margin = options.margin || "";
        this.netPrice = options.netPrice || "";
        this.poType = options.poType || "";
        this.price = options.price || "";
        if (options.product) {
            this.product = {
                id: options.product.id,
                code: options.product.code,
                no: options.product.no,
                name: options.product.name,
                sku: options.product.sku
            }
        } else {
            this.product = {
                id: "",
                code: "",
                no: "",
                name: "",
                sku: ""
            }
        }
        this.profit = options.profit || "";
        this.quantity = options.quantity || "";
        this.quoteCustomImage = options.quoteCustomImage || [];
        if (options.receiving) {
            this.receiving = {
                complete: options.receiving.complete,
                received: options.receiving.received,
                customerComplete: options.receiving.customerComplete,
                customerReceived: options.receiving.customerReceived,                
            }
        } else {
            this.receiving = {
                complete: "",
                received: "",
                customerComplete: "",
                customerReceived: "",                 
            }
        }
        if (options.rollUp) {
            this.rollUp = {
                deco: options.rollUp.deco,
                addon: options.rollUp.addon,
                decoAddon: options.rollUp.decoAddon,                  
            }
        } else {
            this.rollUp = {
                deco: "",
                addon: "",
                decoAddon: "",                            
            }
        }
        if (options.shipInfo) {
            this.shipInfo = {
                date: options.shipInfo.date,
                vendor: options.shipInfo.vendor,
                account: options.shipInfo.account,                  
            }
        } else {
            this.shipInfo = {
                date: "",
                vendor: "",
                account: "",                            
            }
        }
        if (options.shipTo) {
            this.shipTo = {
                name: options.shipTo.name,
                id: options.shipTo.id,
                alternateId: options.shipTo.alternateId,                  
                alternateName: options.shipTo.alternateName,                  
            }
        } else {
            this.shipTo = {
                name: "",
                id: "",
                alternateId: "",                            
                alternateName: "",                            
            }
        }
        if (options.vendor) {
            this.vendor = {
                name: options.vendor.name,
                id: options.vendor.id,
                no: options.vendor.no,                  
                               
            }
        } else {
            this.vendor = {
                name: "",
                id: "",
                no: "",                                                                  
            }
        }
    }

}